import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";

export const companyEventsFetcher = createDraftSafeSelector(
    (state: RootState) => state.companyEventsStore?.companyEvents,
    (companyEvents) => companyEvents || {}
);
export const corporateActionsFetcher = createDraftSafeSelector(
    (state: RootState) => state.companyEventsStore?.corporateActions,
    (corporateActions) => corporateActions || {}
);